import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Input, Button } from '../../components/ds';
import api from '../../api/client';
import logoWhite from '../../assets/vmfive-logo-white.png';
import './PortalLogin.css';

export default function PortalLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      const result = await api.getPortalCompanies();
      if (!result || result.length === 0) {
        setError('此帳號尚未關聯公司，請聯繫管理員');
        return;
      }
      if (result.length === 1) {
        selectCompany(result[0]);
        return;
      }
      setCompanies(result);
      setSelectedCompany(result[0]);
    } catch (err) {
      setError(err.message || '登入失敗');
    } finally {
      setLoading(false);
    }
  };

  const selectCompany = (company) => {
    sessionStorage.setItem('portal_company_id', company.company_id);
    localStorage.setItem('portal_company_name', company.company_name || 'Company');
    navigate('/ads');
  };

  return (
    <div className="login-container">
      {/* Left: Visual */}
      <div className="login-visual">
        <div className="login-visual__content">
          <div className="login-visual__logo">
            <img src={logoWhite} alt="VMFIVE" className="login-visual__logo-img" />
          </div>
          <p className="login-visual__tagline">
            管理您的廣告並追蹤投放成效。
          </p>
        </div>
      </div>

      {/* Right: Form */}
      <div className="login-form-panel">
        {companies ? (
          <>
            <div className="login-form__header">
              <div className="login-form__subtitle">廣告主入口</div>
              <h1 className="login-form__title">選擇公司</h1>
            </div>
            <div className="company-select__list">
              {companies.map((c) => (
                <div
                  key={c.company_id}
                  className={`company-select__item ${selectedCompany?.company_id === c.company_id ? 'company-select__item--active' : ''}`}
                  onClick={() => setSelectedCompany(c)}
                >
                  <div className="company-select__radio">
                    <div className="company-select__radio-dot" />
                  </div>
                  <div>
                    <div className="company-select__name">{c.company_name || c.company_id}</div>
                    <div className="company-select__id">ID: {c.company_id}</div>
                  </div>
                </div>
              ))}
            </div>
            <Button
              style={{ width: '100%', justifyContent: 'center', marginTop: 16 }}
              onClick={() => selectedCompany && selectCompany(selectedCompany)}
            >
              繼續
            </Button>
          </>
        ) : (
          <>
            <div className="login-form__header">
              <div className="login-form__subtitle">廣告主入口</div>
              <h1 className="login-form__title">登入您的帳戶</h1>
              <p className="login-form__desc">管理您的廣告並追蹤投放成效</p>
            </div>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 16 }}>
                <Input label="Email" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" required />
              </div>
              <div style={{ marginBottom: 16 }}>
                <Input label="密碼" type="password" value={password}
                  onChange={(e) => setPassword(e.target.value)} placeholder="請輸入密碼" required />
              </div>

              {error && <div className="login-error">{error}</div>}

              <Button type="submit" disabled={loading}
                style={{ width: '100%', justifyContent: 'center' }}>
                {loading ? '登入中...' : '登入'}
              </Button>
            </form>

            <div className="login-form__footer">
              需要協助？請聯繫 <a href="mailto:support@vmfive.com">support@vmfive.com</a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
